import React from 'react';
import Helmet from 'react-helmet';
import { config } from 'config';
import * as Blocks from '../components/Blocks';

class SiteIndex extends React.Component {
  render() {
    return (
      <div className="wrapper container">
        <Helmet title={config.siteTitle} />
        <Blocks.ProfessionalSkills />
        <Blocks.WorkExperience />
        <Blocks.Education />
        <Blocks.GetInTouch />
      </div>
    );
  }
}

export default SiteIndex;



// WEBPACK FOOTER //
// ./index.jsx